import { ResolvedReason, isResolvedReason } from "../Explore.model";

const resolvedReasonToLabel: Record<ResolvedReason, string> = {
  FULLY_RESOLVED: "Fully Resolved",
  ABANDONED: "Abandoned",
  ABANDONED_DURING_ESCALATION: "Abandoned During Escalation",
  CLOSED_BY_USER: "Closed by User",
  UNCLASSIFIED: "Unclassified",
  ERROR: "Error",
};

export function getResolvedReasonText(value: string): string {
  return isResolvedReason(value) ? resolvedReasonToLabel[value] : "";
}

export function ResolvedReasonFormatter({ value }: { value: string }) {
  if (value == null || !isResolvedReason(value)) {
    return <></>;
  }

  return <>{getResolvedReasonText(value)}</>;
}
